import { useQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import { getOrganizationsCaseDefaultSetups } from '../../caseDefaultSetups';
import { OrganizationQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

const useOrganizationRelatedCaseDefaultSetups = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  const { organizationId } = params;
  return useQuery({
    ...options,
    queryKey: [QueryKeys.getOrganizationsCaseDefaultSetups, organizationId],
    queryFn: async () => {
      const { data } = await getOrganizationsCaseDefaultSetups(organizationId);

      return data.data;
    },
  });
};

export default useOrganizationRelatedCaseDefaultSetups;
